import React from 'react';

class SeosonalSwap extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      StoreMyself: false,
      StoreSorat: false,
      bookSorat: false,
      loading: false,
      firstName: '',
      lastName: '',
      email: '',
      Date: '',
      text: '',
      selectedDate: null,
      selectedTime: null,
      booksubmited: false,
      reservationCode: '',
      selectedYear: null,
      selectedMonth: null,
      selectedDay: null,
      serverDate: null,
      serverDateString: null,
      bookedTimes: [],
      blockedDates: [],
      fullyBookedDates: [],
      formData: {
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        carType: '',
      },
      imageUrl: '',
      offsetDays: 1,
      duplicateDialogOpen: false,
      duplicateInfo: null,
      allBookings: [],
      // Vehicle selection fields
      vehicles: null,
      selectedCarYear: '',
      selectedCarMake: '',
      selectedCarModel: '',
      availableMakes: [],
      customerChecked: false,
      customerVehicles: [],
      customerBookings: [],
      customerStorage: [],
      selectedExistingVehicle: null,
      showNewVehicleForm: false,
      checkingCustomer: false,
      vehicleModalOpen: false,
      selectedStorageLocation: '',
      selectedOnRim: null,
      storageNotFoundDialogOpen: false,
      storageConfirmDialogOpen: false,
      storageConfirmInfo: null,
      selectedTreadDepth: null,
    };
  }

  componentDidMount() {
    this.checkAndLoadVehicles();
    
    fetch('https://panel.sorat.ca/apii/get_server_time.php')
      .then(response => response.json())
      .then(data => {
        if (data.success && data.server_time) {
          // The server returns Vancouver's current date/time (already DST-corrected).
          // Keep the date part as the authoritative Vancouver "today" so the calendar
          // never drifts due to the customer's local timezone or DST transitions.
          const serverDate = new Date(data.server_time);
          const serverDateString = data.server_time.slice(0, 10); // YYYY-MM-DD
          this.setState({ serverDate, serverDateString });
        }
      })
      .catch(err => {
        console.error("Failed to load server date", err);
        // Fallback is handled in getVancouverTodayRaw() using the Vancouver timezone.
        this.setState({ serverDate: null, serverDateString: null });
      });

    fetch('https://panel.sorat.ca/apii/get_blocked_dates.php')
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          this.setState({ blockedDates: data.blocked_dates });
        }
      })
      .catch(err => console.error("Failed to load blocked dates", err));

    this.fetchBookedTimes();
  }

  checkAndLoadVehicles = () => {
    const vehicles = localStorage.getItem('vehicles');
    
    const vehiclesTimes = localStorage.getItem('vehicles_times');
    
    if (!vehicles || !vehiclesTimes) {
      this.loadVehiclesFromAPI();
    } else {
      // Check if data is older than 3 days
      const savedDate = new Date(vehiclesTimes);
      const today = new Date();
      const diffTime = Math.abs(today - savedDate);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      
      if (diffDays > 3) {
        this.loadVehiclesFromAPI();
      } else {
        this.setState({ vehicles: JSON.parse(vehicles) });
      }
    }
  }

  loadVehiclesFromAPI = () => {
    fetch('https://soratwheels.ca/apii/getvehicle.php')
      .then(response => response.json())
      .then(data => {
        const today = new Date().toString();
        localStorage.setItem('vehicles', JSON.stringify(data));
        localStorage.setItem('vehicles_times', today);
        this.setState({ vehicles: data });
      })
      .catch(error => {
        console.error('Error loading vehicles:', error);
      });
  }

  handleCarYearChange = (e) => {
    const year = e.target.value;
    const makes = this.state.vehicles && this.state.vehicles[year] ? Object.keys(this.state.vehicles[year]) : [];
    
    this.setState({
      selectedCarYear: year,
      selectedCarMake: '',
      selectedCarModel: '',
      availableMakes: makes
    }, this.updateCarType);
  }

  handleCarMakeChange = (e) => {
    const make = e.target.value;
    this.setState({
      selectedCarMake: make,
      selectedCarModel: ''
    }, this.updateCarType);
  }

  handleCarModelChange = (e) => {
    this.setState({
      selectedCarModel: e.target.value
    }, this.updateCarType);
  }

  updateCarType = () => {
    const { selectedCarYear, selectedCarMake, selectedCarModel } = this.state;
    if (selectedCarYear && selectedCarMake && selectedCarModel) {
      const carType = selectedCarYear + ' ' + selectedCarMake + ' ' + selectedCarModel;
      const formData = Object.assign({}, this.state.formData);
      formData.carType = carType;
      this.setState({ formData });
    }
  }

  fetchBookingSettings = () => {
    fetch('https://panel.sorat.ca/apii/get_booking_settings.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ text: this.state.text })
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        this.setState({
          // offsetDays: data.offsetDays  || 2,
          offsetDays: data.offsetDays !== undefined ? data.offsetDays : 2,
          slotDuration: data.slotDuration || 30,
          fullyBookedDates: Array.isArray(data.fullyBookedDates) ? data.fullyBookedDates : [],
          loading: false
        });
      } else {
        console.error('Booking settings not found');
        this.setState({ loading: false });
      }
    })
    .catch(error => {
      console.error('Error fetching booking settings:', error);
      this.setState({ loading: false });
    });
  }
  
  startSeasonalShopping = (category) => {
    if (category === 'My Wheels/Tires are stored with Sorat Wheels') {
      if (!window.localStorage.getItem("storage") || window.localStorage.getItem("storage")) {
        window.localStorage.setItem("storage", " ");
      }
      this.setState({ 
        text: 'My Wheels and/or Tires are stored with Sorat Wheels',
        bookSorat: true,
        loading: true
      }, this.fetchBookingSettings);
    } else {
      this.setState({ 
        StoreMyself: true
      });
    }
  }   
   renderSeasonalCategory = (imageUrl, category, disabled) => {
    return (

     <div className="categories-block__column_hooman categories-block__column">
       <div className="categories-block__column__imageContainer">
         <img src={window.host + imageUrl} style={{ width: '100%', height: '100%' }} className="categories-block__image" />
       </div>
       <div className="categories-block__btn-container_afterstorage" />
       <div className="categories-block__btn-container">
        <button 
            disabled={disabled}
            className={`categories-block__btnstorage ${disabled ? 'disabled-btn' : ''}`}
            onClick={() => this.startSeasonalShopping(category)}
            style={{
              cursor: disabled ? 'not-allowed' : 'pointer',
              backgroundColor: disabled ? '#ccc' : '#c50000',
              color: disabled ? '#666' : '#fff',
              border: disabled ? '1px solid #aaa' : '0px solid rgb(13, 13, 14)',
              font: '-webkit-control',
              height: '70px',
              textTransform: 'uppercase'
            }}
          >
           {category}
         </button>
       </div>
     </div>
    );
  }

  renderSeasonalCategoryPanels = () => {
    return (
      <div className="categories-block__categories-box" style={{ width: '100%' }}>
        
       <div id="categoryImageAndButtons" className="categories-block__row">
         {/* <h2 style={{ color: '#ffffff', textAlign: 'center', fontWeight: '700', margin: '0', paddingTop: '1px', paddingBottom: '15px' }}>Online Booking(Seasonal Swap Over)</h2> */}
         { this. renderSeasonalCategory('/statics/img/winterstore.jpg', 'My Wheels/Tires are stored with Sorat Wheels', false) }
         { this. renderSeasonalCategory('/statics/img/swap02.jpg', 'I have my Wheels/Tires and will bring with me to the appointment', false) }
       </div>
     </div>
    );
  }

  getVancouverTodayRaw() {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/Vancouver',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).formatToParts(new Date());
    const map = {};
    parts.forEach(part => { map[part.type] = part.value; });
    return `${map.year}-${map.month}-${map.day}`;
  }

  getDatesFromToday(offsetDays, numDays) {
    const dates = [];
    const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    // "Today" in Vancouver: prefer the server-reported date (authoritative and already
    // DST-corrected on the API), otherwise derive it from the Vancouver timezone.
    const todayRaw = this.state.serverDateString || this.getVancouverTodayRaw();
    const [baseYear, baseMonth, baseDay] = todayRaw.split('-').map(Number);

    // Anchor at UTC noon so adding whole days never crosses a Vancouver date boundary.
    const base = new Date(Date.UTC(baseYear, baseMonth - 1, baseDay, 12, 0, 0));

    for (let i = offsetDays; i < offsetDays + numDays; i++) {
      const date = new Date(base.getTime() + i * 24 * 60 * 60 * 1000);
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, '0');
      const day = String(date.getUTCDate()).padStart(2, '0');

      dates.push({
        weekday: weekdays[date.getUTCDay()],
        dayMonth: `${months[date.getUTCMonth()]} ${date.getUTCDate()}`,
        year: year,
        raw: `${year}-${month}-${day}`,
        isSunday: date.getUTCDay() === 0,
      });
    }

    return dates;
  }

  handleDateClick(date, year, dayMonth, weekday) {
      // First refresh the booking data to ensure we have the latest information
    this.refreshBookingData(date).then(() => {
      // Then set the selected date after data is refreshed
      this.setState({ 
        selectedDate: date, 
        selectedYear: year, 
        selectedMonth: dayMonth, 
        selectedDay: weekday
      });
      console.log('selectedDate:', date);
    });
  }

  handleTimeClick(time) {
    this.setState({ selectedTime: time });
  }

  handleFormChange = (e) => {
    const { name, value } = e.target;
    const formData = Object.assign({}, this.state.formData);
    formData[name] = value;
    this.setState({ formData });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    
    // Prevent double submission
    if (this.state.isSubmitting) {
      return;
    }
    
    this.setState({ isSubmitting: true });
    
    const userEmail = this.state.formData.email.toLowerCase();
    // Get today's date in Vancouver timezone (using local components, NOT toISOString which converts to UTC and shifts the date after 5 PM)
    const vancouverTime = new Date().toLocaleString("en-US", { timeZone: "America/Vancouver" });
    const vancouverDate = new Date(vancouverTime);
    const todayYear = vancouverDate.getFullYear();
    const todayMonth = String(vancouverDate.getMonth() + 1).padStart(2, '0');
    const todayDay = String(vancouverDate.getDate()).padStart(2, '0');
    const todayFormatted = `${todayYear}-${todayMonth}-${todayDay}`;
    
    // Find valid bookings (not cancelled and date is today or in the future)
    const existingBooking = this.state.allBookings.find(booking => 
      booking.email && 
      booking.email.toLowerCase() === userEmail &&
      booking.reservation_code && 
      !booking.reservation_code.includes('CANCEL') &&
      booking.dateday && 
      booking.dateday > todayFormatted
    );
    
    if (existingBooking) {
      // Found valid duplicate booking
      console.log('Duplicate booking found:', existingBooking);
      this.setState({
        duplicateDialogOpen: true,
        duplicateInfo: {
          date: existingBooking.dateday,
          time: existingBooking.datetime,
          reservationCode: existingBooking.reservation_code          
        },
        isSubmitting: false // Reset here too
      });
    } else {
      // No valid duplicate, proceed with normal booking
      this.submitBooking(false);
    }
  }

  submitBooking = (replaceExisting) => {
    
    const calculateEndTime = (startTime, durationMinutes) => {
      const [hours, minutes] = startTime.split(':').map(Number);
      let totalMinutes = hours * 60 + minutes + durationMinutes;
      const newHours = Math.floor(totalMinutes / 60);
      const newMinutes = totalMinutes % 60;
      return `${newHours}:${newMinutes === 0 ? '00' : newMinutes}`;
    };

    // Normalize phone number - remove spaces, +, (, ) and keep only digits
    const normalizedPhone = this.state.formData.phone.replace(/\D/g, '');
    const endTime = calculateEndTime(this.state.selectedTime, this.state.slotDuration || 30);
    
    // Build note with storage location for stored tires
    let note = this.state.text;
    if (this.state.text === 'My Wheels and/or Tires are stored with Sorat Wheels' && this.state.selectedStorageLocation) {
      note = `${note}\nStorage Location: ${this.state.selectedStorageLocation}`;
    }
    
    // Determine calendar color based on service type
    let color;
    if (this.state.text.includes('Sorat')) {
      // Stored with Sorat Wheels: green when on rims (on_rim=1), blue when loose (on_rim=0)
      color = String(this.state.selectedOnRim) === '0' ? 'blue' : '#255706';
    } else if (this.state.text.includes('bolted on')) {
      color = '#255706';
    } else if (this.state.text.includes('Loose')) {
      color = 'blue';
    } else {
      color = 'red';
    }

    const templateParams = Object.assign({}, this.state.formData, {
      phone: normalizedPhone,
      datetime: `${this.state.selectedTime}`,
      dateday: `${this.state.selectedDate}`,
      endtime: endTime ? endTime : '',
      note: note,
      color: color,
      replaceExisting: replaceExisting,
      oldReservationCode: replaceExisting && this.state.duplicateInfo ? this.state.duplicateInfo.reservationCode : null
    });

    fetch('https://soratwheels.ca/apii/submitcalender.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(templateParams),
    })
    .then(response => response.json())
    .then(data => {
      console.log("API Response:", data); 
      this.setState({ isSubmitting: false });

      if (data.success) {
        this.setState({ 
          booksubmited: true, 
          reservationCode: data.reservationCode,
          duplicateDialogOpen: false
        }, () => {
          console.log("Updated State:", this.state.booksubmited, this.state.reservationCode); 
        });

        // Choose email endpoint: storage email only when stored with Sorat AND tires need replacement
        const emailEndpoint = (this.state.text.includes('My Wheels and/or Tires are stored with Sorat Wheels') && this.shouldBlockForTreadDepth(this.state.selectedTreadDepth))
          ? 'https://panel.sorat.ca/apii/sendemailstorage.php'
          : 'https://panel.sorat.ca/apii/sendemail.php';

        fetch(emailEndpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: this.state.formData.email,
            firstName: this.state.formData.firstName,
            lastName: this.state.formData.lastName,
            reservationCode: data.reservationCode,
            date: data.date,
            time: this.state.selectedTime,
            note: note,
            car: this.state.formData.carType,
            phone: normalizedPhone,
            isReplacement: replaceExisting
          }),
        });
      } else {
        alert("Failed to book appointment: " + data.message);
      }
    })
    .catch(error => {
      console.error('Error:', error);
      this.setState({ isSubmitting: false });
    });
  }

  handleDuplicateYes = () => {
    // User wants to book for a new car
    this.submitBooking(false);
  }

  handleDuplicateNo = () => {
    // User wants to change the existing appointment
    this.submitBooking(true);
  }

  handleCloseDuplicateDialog = () => {
    this.setState({ duplicateDialogOpen: false });
  }

  renderDuplicateDialog() {
    if (!this.state.duplicateDialogOpen || !this.state.duplicateInfo) return null;
    
    return (
      <div className="modal" style={{
        display: 'block',
        position: 'fixed',
        zIndex: 99999,
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        overflow: 'auto',
        backgroundColor: 'rgba(0,0,0,0.7)'
      }}>
        <div className="modal-content" style={{
          backgroundColor: '#fefefe',
          margin: '15% auto',
          padding: '30px',
          border: '1px solid #888',
          width: '80%',
          maxWidth: '500px',
          borderRadius: '10px'
        }}>
          <h3 style={{color: '#c50000', marginBottom: '15px'}}>Existing Booking Found</h3>
          <div style={{marginBottom: '20px', lineHeight: '1.8'}}>
            <p>You already have a booking</p>
            <ul style={{listStyle: 'none', padding: '10px 0', backgroundColor: '#f5f5f5', borderRadius: '5px', marginTop: '10px'}}>
              <li style={{paddingBottom: '5px'}}><strong>Date:</strong> <span style={{color: '#c50000', fontWeight: 'bold'}}>{this.state.duplicateInfo.date}</span></li>
              <li style={{paddingBottom: '5px'}}><strong>Time:</strong> <span>{this.state.duplicateInfo.time}</span></li>
              <li style={{paddingBottom: '5px'}}><strong>Vehicle:</strong> <span>{this.state.duplicateInfo.carType}</span></li>
              {/* <li style={{paddingBottom: '5px', textAlign: 'left'}}><strong>Service:</strong> <span>{this.state.duplicateInfo.note}</span></li> */}
              <li style={{ paddingBottom: '5px' }}><strong>Service:</strong>
                <span>
                  {this.state.duplicateInfo.note &&
                  this.state.duplicateInfo.note.length > 50
                    ? this.state.duplicateInfo.note.substring(0, 50) + '...'
                    : this.state.duplicateInfo.note}
                </span>
              </li>
              <li style={{paddingTop: '10px'}}><strong>Reservation Code:</strong> <span style={{color: '#420b0b', fontWeight: 'bold'}}>{this.state.duplicateInfo.reservationCode}</span></li>
            </ul>
            <p style={{marginTop: '15px', color: '#666'}}>
              Do you want to change this appointment or make a new booking?
            </p>
          </div>
          <div style={{display: 'flex', gap: '10px', justifyContent: 'space-between'}}>
            <button 
              onClick={this.handleDuplicateNo}
              disabled={this.state.isSubmitting}
              style={{
                flex: 1,
                padding: '12px',
                backgroundColor: this.state.isSubmitting ? '#ccc' : '#c50000',
                color: '#fff',
                border: 'none',
                borderRadius: '5px',
                cursor: this.state.isSubmitting ? 'not-allowed' : 'pointer',
                fontSize: '14px'
              }}
            >
              Change Appointment
            </button>

            <button 
              onClick={this.handleDuplicateOk}
              style={{
                flex: 1,
                padding: '12px',
                backgroundColor: '#255706',
                color: '#fff',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              Make New Booking
            </button>
          </div>
        </div>
      </div>
    );
  }

  getMaxBookingsForSlot = (slot) => {
    return (slot === '13:00' || slot === '13:30') ? 2 : 3;
  }

  renderTimeSlots() {
    const now = new Date().getTime();
    if (!this.lastRefreshTime || (now - this.lastRefreshTime > 60000)) {
      this.refreshBookingData(this.state.selectedDate);
      this.lastRefreshTime = now;
    }
    
    const slots = [];
    const selectedDay = this.state.selectedDate ? this.state.selectedDate : null;
    const bookedForSelectedDay = selectedDay ? this.state.bookedTimes[selectedDay] || [] : [];

    // Get current Vancouver time
    const vancouverTime = new Date().toLocaleString("en-US", { timeZone: "America/Vancouver" });
    const currentVancouverDate = new Date(vancouverTime);
    const currentVancouverHour = currentVancouverDate.getHours();
    const currentVancouverMinute = currentVancouverDate.getMinutes();
    
    // Get today's date in Vancouver timezone (using local components, NOT toISOString which converts to UTC and shifts the date after 5 PM)
    const todayYear = currentVancouverDate.getFullYear();
    const todayMonth = String(currentVancouverDate.getMonth() + 1).padStart(2, '0');
    const todayDay = String(currentVancouverDate.getDate()).padStart(2, '0');
    const todayDateString = `${todayYear}-${todayMonth}-${todayDay}`;
    const isToday = selectedDay === todayDateString;

    const bookingCounts = {};
    bookedForSelectedDay.forEach(slot => {
      bookingCounts[slot] = (bookingCounts[slot] || 0) + 1;
    });

    const stepMinutes = this.state.slotDuration || 30; 
    const startHour = this.state.selectedDay === 'Saturday' ? 10 : 9;
    const endHour = this.state.selectedDay === 'Saturday' ? 14 : 16;

    for (let hour = startHour; hour <= endHour; hour++) {
      for (let minute = 0; minute < 60; minute += stepMinutes) {
        const formattedHour = hour.toString().padStart(2, '0'); 
        const formattedMinute = minute === 0 ? '00' : minute.toString().padStart(2, '0');
        const slot = `${formattedHour}:${formattedMinute}`; 

        const count = bookingCounts[slot] || 0;
        const maxBookings = this.getMaxBookingsForSlot(slot);
        const isBooked = count >= maxBookings;
        
        // Check if slot is in the past (ONLY for today, with 2 hour buffer)
        let isPastTime = false;
        if (isToday) {
          const slotTotalMinutes = hour * 60 + minute;
          const currentTotalMinutes = currentVancouverHour * 60 + currentVancouverMinute + 180; // 3 hour buffer
          isPastTime = slotTotalMinutes < currentTotalMinutes;
        }

        const isDisabled = isBooked || isPastTime;

        slots.push(
          <button
            className="vehicleSelection-contentTires__btnlist"
            key={slot}
            style={{
              margin: '5px',
              padding: '10px 15px',
              cursor: isDisabled ? 'not-allowed' : 'pointer',
              opacity: isDisabled ? 0.5 : 1,
              backgroundColor: isDisabled ? '#555' : '#c50000',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: '500',
              transition: 'all 0.3s ease',
              boxShadow: isDisabled ? 'none' : '0 4px 6px rgba(0,0,0,0.3)'
            }}
            disabled={isDisabled}
            onClick={() => !isDisabled && this.handleTimeClick(slot)}
            title={isPastTime ? 'This time has passed' : (isBooked ? 'Fully booked' : '')}
          >
            {slot}
          </button>
        );
      }
    }
    return slots;
  }
    
  fetchBookedTimes() {
    fetch('https://soratwheels.ca/apii/booklist.php')
      .then(response => response.json())
      .then(data => {
        if (data.success && data.booked) {
          const bookedMap = {};
          // Store all bookings with complete info
          this.setState({ allBookings: data.booked });
          
          data.booked.forEach(item => {
            if (!bookedMap[item.dateday]) {
              bookedMap[item.dateday] = [];
            }
            bookedMap[item.dateday].push(item.datetime);
          });
          this.setState({ bookedTimes: bookedMap });
        }
      })
      .catch(error => console.error('Error fetching booked times:', error));
  }

  renderForm() {
    const { firstName, lastName, phone, email } = this.state.formData;
    const years = this.state.vehicles ? Object.keys(this.state.vehicles).sort((a, b) => b - a) : [];

    // Step 1: Customer Information (before checking)
    if (!this.state.customerChecked) {
      return (
        <form onSubmit={this.handleCheckCustomer} style={{ marginTop: '20px', maxWidth: '600px', margin: '20px auto', padding: '10px' }}>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
            <input type="text" name="firstName" placeholder="First Name" value={firstName} onChange={this.handleFormChange} required style={{ flex: '1', width: '100%', padding: '8px' }} />
            <input type="text" name="lastName" placeholder="Last Name" value={lastName} onChange={this.handleFormChange} required style={{ width: '100%', flex: '1', padding: '8px' }} />
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginTop: '10px' }}>
            <input 
              type="tel" 
              name="phone" 
              placeholder="Phone (e.g., 6041234567)" 
              value={phone} 
              onChange={this.handleFormChange} 
              required 
              style={{ width: '100%', flex: '1', padding: '8px' }} 
            />
            <input type="email" name="email" placeholder="Email" value={email} onChange={this.handleFormChange} required style={{ width: '100%', flex: '1', padding: '8px' }} />
          </div>
          
          <button 
            type="submit" 
            disabled={this.state.checkingCustomer}
            style={{ 
              width: '60%', 
              padding: '10px', 
              marginTop: '20px', 
              backgroundColor: this.state.checkingCustomer ? '#ccc' : '#c50000', 
              color: this.state.checkingCustomer ? '#666' : '#fff', 
              border: 'none', 
              borderRadius: '5px',
              cursor: this.state.checkingCustomer ? 'not-allowed' : 'pointer'
            }}
          >
            {this.state.checkingCustomer ? 'Checking...' : 'Next'}
          </button>
        </form>
      );
    }

    // Step 2: Vehicle Selection Form (after checking - new customer or no vehicles)
    return (
      <form onSubmit={this.handleSubmit} style={{ marginTop: '20px', maxWidth: '600px', margin: '20px auto', padding: '10px' }}>
        {/* Customer info (read-only) */}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginBottom: '10px' }}>
          <input type="text" value={firstName} disabled style={{ flex: '1', padding: '8px', backgroundColor: '#f0f0f0' }} />
          <input type="text" value={lastName} disabled style={{ flex: '1', padding: '8px', backgroundColor: '#f0f0f0' }} />
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginBottom: '20px' }}>
          <input type="tel" value={phone} disabled style={{ flex: '1', padding: '8px', backgroundColor: '#f0f0f0' }} />
          <input type="email" value={email} disabled style={{ flex: '1', padding: '8px', backgroundColor: '#f0f0f0' }} />
        </div>

        {/* Vehicle selection */}
        {this.state.selectedExistingVehicle ? (
          <div style={{ marginBottom: '20px' }}>
            <h4 style={{ color: '#fff', marginBottom: '10px' }}>Selected Vehicle:</h4>
            <div style={{
              padding: '15px',
              backgroundColor: '#570606',
              color: '#fff',
              borderRadius: '5px',
              fontSize: '16px',
              fontWeight: 'bold'
            }}>
              {this.state.selectedExistingVehicle}
            </div>
          </div>
        ) : (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginTop: '10px' }}>
            <select 
              value={this.state.selectedCarYear} 
              onChange={this.handleCarYearChange} 
              required 
              style={{ flex: '1', minWidth: '120px', padding: '8px', backgroundColor: '#fff' }}
            >
              <option value="">Select Year</option>
              {years.map(year => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
            
            <select 
              value={this.state.selectedCarMake} 
              onChange={this.handleCarMakeChange} 
              disabled={!this.state.selectedCarYear}
              required 
              style={{ flex: '1', minWidth: '120px', padding: '8px', backgroundColor: '#fff', opacity: !this.state.selectedCarYear ? 0.5 : 1 }}
            >
              <option value="">Select Make</option>
              {this.state.availableMakes.map(make => (
                <option key={make} value={make}>{make}</option>
              ))}
            </select>
            
            <input 
              type="text" 
              placeholder="Model (e.g., X5)" 
              value={this.state.selectedCarModel} 
              onChange={this.handleCarModelChange}
              disabled={!this.state.selectedCarMake}
              required 
              style={{ flex: '1', minWidth: '120px', padding: '8px', backgroundColor: '#fff', opacity: !this.state.selectedCarMake ? 0.5 : 1 }}
            />
          </div>
        )}

        <input type="text" name="note" value={this.state.text + (this.state.selectedStorageLocation ? '\nStorage Location: ' + this.state.selectedStorageLocation : '')} hidden />

        {/* Submit Button */}
        <button 
          type="submit" 
          disabled={this.state.isSubmitting}
          style={{ 
            width: '60%', 
            padding: '10px', 
            marginTop: '20px', 
            backgroundColor: this.state.isSubmitting ? '#ccc' : '#c50000', 
            color: this.state.isSubmitting ? '#666' : '#fff', 
            border: 'none', 
            borderRadius: '5px',
            cursor: this.state.isSubmitting ? 'not-allowed' : 'pointer',
            opacity: this.state.isSubmitting ? 0.6 : 1
          }}
        >
          {this.state.isSubmitting ? 'Processing...' : 'Submit'}
        </button>
      </form>
    );
  }

  handleBack = () => {
    this.setState({ selectedDate: null, selectedTime: null, StoreSorat: false });
  };

  handleNext = () => {
    this.setState((prevState) => {
      const newOffset = prevState.offsetDays + 12;
      return newOffset <= 60 ? { offsetDays: newOffset } : prevState;
    });
  };

  handlePrev = () => {
    this.setState((prevState) => {
      const newOffset = prevState.offsetDays - 12;
      return newOffset >= 0 ? { offsetDays: newOffset } : { offsetDays: this.state.offsetDays };
    });
  };

  // New function to refresh booking data for a specific date
  refreshBookingData(date) {
    return new Promise((resolve, reject) => {
      // Show loading indicator
      this.setState({ loading: true });
      
      // Force cache busting by adding timestamp to URL
      const timestamp = new Date().getTime();
      fetch(`https://soratwheels.ca/apii/booklist.php?nocache=${timestamp}`)
        .then(response => response.json())
        .then(data => {
          if (data.success && data.booked) {
            const bookedMap = {};
            // Store all bookings with complete info
            this.setState({ allBookings: data.booked });
            
            data.booked.forEach(item => {
              if (!bookedMap[item.dateday]) {
                bookedMap[item.dateday] = [];
              }
              bookedMap[item.dateday].push(item.datetime);
            });
            
            this.setState({ 
              bookedTimes: bookedMap,
              loading: false 
            }, () => {
              resolve();
            });
          } else {
            this.setState({ loading: false });
            resolve();
          }
        })
        .catch(error => {
          console.error('Error fetching booked times:', error);
          this.setState({ loading: false });
          reject(error);
        });
    });
  }

  // Phone validation function
  validatePhone = (phone) => {
    // Remove all non-digit characters
    const cleanPhone = phone.replace(/\D/g, '');
    
    // Check if it has 10 or 11 digits
    return cleanPhone.length >= 10 && cleanPhone.length <= 11;
  }

  // Check if the stored tires need replacement
  shouldBlockForTreadDepth = (treadDepth) => {
    const normalized = (treadDepth || '').trim().toUpperCase();
    return normalized === 'REPLACE ALL 4 TIRES' ||
           normalized === 'REPLACE FRONT TIRES' ||
           normalized === 'REPLACE REAR TIRES';
  }

  handleCheckCustomer = (e) => {
    e.preventDefault();
    
    if (this.state.checkingCustomer) return;
    
    const { firstName, lastName, phone, email } = this.state.formData;
    
    // Validate phone number format
    if (!this.validatePhone(phone)) {
      alert('Please enter a valid phone number with 10 digits (e.g., (604) 123-4567 or 6041234567)');
      return;
    }
    
    this.setState({ checkingCustomer: true });
    
    const normalizedPhone = phone.replace(/\D/g, '');
    
    fetch('https://soratwheels.ca/apii/checkcustomer.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ phone: normalizedPhone })
    })
    .then(response => response.json())
    .then(data => {
      this.setState({ checkingCustomer: false });
      
      const isStorageMode = this.state.text === 'My Wheels and/or Tires are stored with Sorat Wheels';
      
      if (isStorageMode) {
        // Storage mode: customer must exist AND have storage records
        const storageRecords = data.storage || [];
        
        if (data.ok && data.found && storageRecords.length > 0) {
          // Build vehicle list from storage records
          let allVehicles = [];
          const seen = new Set();
          
          storageRecords.forEach(sr => {
            (sr.vehicle || []).forEach(v => {
              if (!seen.has(v.id)) {
                seen.add(v.id);
                const matchingStorage = storageRecords.find(rec => String(rec.vehicle_id) === String(v.id));
                allVehicles.push(Object.assign({}, v, {
                  hasStorage: !!matchingStorage,
                  storageLocation: matchingStorage ? matchingStorage.storage : null,
                  onRim: matchingStorage ? matchingStorage.on_rim : null,
                  treadDepth: matchingStorage ? matchingStorage.tread_depth : null
                }));
              }
            });
          });
          
          // Fallback: if storage records don't include vehicle arrays, use top-level vehicle list
          if (allVehicles.length === 0 && data.vehicle && data.vehicle.length > 0) {
            allVehicles = data.vehicle.map(v => {
              const matchingStorage = storageRecords.find(rec => String(rec.vehicle_id) === String(v.id));
              return Object.assign({}, v, {
                hasStorage: !!matchingStorage,
                storageLocation: matchingStorage ? matchingStorage.storage : null,
                onRim: matchingStorage ? matchingStorage.on_rim : null,
                treadDepth: matchingStorage ? matchingStorage.tread_depth : null
              });
            });
          }
          
          // Filter vehicles that start with 4-digit year
          const validVehicles = allVehicles.filter(vehicleObj => {
            const vehicleStr = vehicleObj.vehicle || '';
            return /^\d{4}/.test(vehicleStr);
          });
          
          if (validVehicles.length > 0) {
            // Customer exists with stored vehicles - show modal
            this.setState({
              customerChecked: true,
              customerVehicles: validVehicles,
              customerStorage: storageRecords,
              customerBookings: data.booking || [],
              vehicleModalOpen: true,
              selectedExistingVehicle: null,
              showNewVehicleForm: false,
              selectedStorageLocation: ''
            });
          } else {
            // No valid stored vehicles found
            this.setState({
              customerChecked: false,
              storageNotFoundDialogOpen: true
            });
          }
        } else {
          // Customer not found or no storage records
          this.setState({
            customerChecked: false,
            storageNotFoundDialogOpen: true
          });
        }
      } else if (data.ok && data.found && data.vehicle && data.vehicle.length > 0) {
        // Filter vehicles that start with 4-digit year
        const validVehicles = data.vehicle.filter(vehicleObj => {
          const vehicleStr = vehicleObj.vehicle || '';
          // Check if starts with exactly 4 digits
          const startsWithYear = /^\d{4}/.test(vehicleStr);
          return startsWithYear;
        });
        
        if (validVehicles.length > 0) {
          // Customer exists with valid vehicles - show modal
          this.setState({
            customerChecked: true,
            customerVehicles: validVehicles,
            customerStorage: data.storage || [],
            customerBookings: data.booking || [],
            vehicleModalOpen: true,
            selectedExistingVehicle: null,
            showNewVehicleForm: false
          });
        } else {
          // No valid vehicles found - show new vehicle form
          this.setState({
            customerChecked: true,
            customerVehicles: [],
            customerStorage: data.storage || [],
            customerBookings: [],
            showNewVehicleForm: true,
            vehicleModalOpen: false
          });
        }
      } else {
        // New customer or no vehicles - show form
        this.setState({
          customerChecked: true,
          customerVehicles: [],
          customerStorage: data.storage || [],
          customerBookings: [],
          showNewVehicleForm: true,
          vehicleModalOpen: false
        });
      }
    })
    .catch(error => {
      console.error('Error checking customer:', error);
      this.setState({ 
        checkingCustomer: false,
        customerChecked: true,
        showNewVehicleForm: true
      });
    });
  }

  handleVehicleSelection = (vehicleObj) => {
    const vehicleName = vehicleObj.vehicle;
    const formData = Object.assign({}, this.state.formData);
    formData.carType = vehicleName;
    
    const isStorageMode = this.state.text === 'My Wheels and/or Tires are stored with Sorat Wheels';
    const storageLocation = isStorageMode ? (vehicleObj.storageLocation || '') : '';
    const onRim = isStorageMode ? vehicleObj.onRim : null;
    const treadDepth = isStorageMode ? vehicleObj.treadDepth : null;
    
    // NEW: Customer chose "bring my own" but their tires for this vehicle are stored with us
    const matchingStorage = !isStorageMode ? (this.state.customerStorage || []).find(rec => String(rec.vehicle_id) === String(vehicleObj.id)) : null;
    if (matchingStorage) {
      // Ask the customer if they want to book using their stored package instead
      this.setState({
        selectedExistingVehicle: vehicleName,
        formData,
        vehicleModalOpen: false,
        storageConfirmDialogOpen: true,
        storageConfirmInfo: {
          vehicleName: vehicleName,
          storageLocation: matchingStorage.storage ? matchingStorage.storage : '',
          onRim: matchingStorage.on_rim,
          treadDepth: matchingStorage.tread_depth
        }
      });
      return;
    }

    // Check if there's an existing booking for this vehicle
    const existingBooking = this.state.customerBookings.find(booking => 
      booking.car_type === vehicleName
    );
    
    if (existingBooking) {
      // Found duplicate booking for this vehicle
      this.setState({
        selectedExistingVehicle: vehicleName,
        selectedStorageLocation: storageLocation,
        selectedOnRim: onRim,
        selectedTreadDepth: treadDepth,
        formData,
        vehicleModalOpen: false,
        duplicateDialogOpen: true,
        duplicateInfo: {
          date: existingBooking.dateday,
          time: existingBooking.datetime,
          reservationCode: existingBooking.reservation_code,
          carType: existingBooking.car_type,
          note: existingBooking.note
        }
      });
    } else {
      // No duplicate, just select the vehicle
      this.setState({ 
        selectedExistingVehicle: vehicleName,
        selectedStorageLocation: storageLocation,
        selectedOnRim: onRim,
        selectedTreadDepth: treadDepth,
        formData,
        vehicleModalOpen: false,
        showNewVehicleForm: false
      });
    }
  }

  openDuplicateDialogForVehicle = (vehicleName) => {
    const existingBooking = this.state.customerBookings.find(booking => 
      booking.car_type === vehicleName
    );
    
    if (existingBooking) {
      this.setState({
        duplicateDialogOpen: true,
        duplicateInfo: {
          date: existingBooking.dateday,
          time: existingBooking.datetime,
          reservationCode: existingBooking.reservation_code,
          carType: existingBooking.car_type,
          note: existingBooking.note
        }
      });
      return true;
    }
    return false;
  }

  handleStorageConfirmYes = () => {
    const info = this.state.storageConfirmInfo || {};
    
    this.setState({
      text: 'My Wheels and/or Tires are stored with Sorat Wheels',
      selectedStorageLocation: info.storageLocation || '',
      selectedOnRim: info.onRim,
      selectedTreadDepth: info.treadDepth,
      storageConfirmDialogOpen: false
    }, () => {
      if (info.vehicleName) {
        this.openDuplicateDialogForVehicle(info.vehicleName);
      }
    });
  }

  handleStorageConfirmNo = () => {
    const info = this.state.storageConfirmInfo || {};
    
    this.setState({
      storageConfirmDialogOpen: false
    }, () => {
      if (info.vehicleName) {
        this.openDuplicateDialogForVehicle(info.vehicleName);
      }
    });
  }

  handleNewVehicleClick = () => {
    // In storage mode, adding a different vehicle is not allowed
    if (this.state.text === 'My Wheels and/or Tires are stored with Sorat Wheels') return;
    
    this.setState({ 
      showNewVehicleForm: true,
      selectedExistingVehicle: null,
      vehicleModalOpen: false
    });
  }

  handleDuplicateOk = () => {
    // User acknowledges the duplicate and wants to proceed with new booking
    this.setState({
      duplicateDialogOpen: false
    });
  }

  handleCloseStorageNotFoundDialog = () => {
    this.setState({ storageNotFoundDialogOpen: false });
  }

  renderStorageNotFoundDialog() {
    if (!this.state.storageNotFoundDialogOpen) return null;
    
    return (
      <div className="modal" style={{
        display: 'block',
        position: 'fixed',
        zIndex: 99999,
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        overflow: 'auto',
        backgroundColor: 'rgba(0,0,0,0.7)'
      }}>
        <div className="modal-content" style={{
          backgroundColor: '#fefefe',
          margin: '15% auto',
          padding: '30px',
          border: '1px solid #888',
          width: '80%',
          maxWidth: '500px',
          borderRadius: '10px'
        }}>
          <h3 style={{color: '#c50000', marginBottom: '15px'}}>No Stored Tires Found</h3>
          <div style={{marginBottom: '20px', lineHeight: '1.8'}}>
            <p>No stored tires found for this customer. Please contact us <a href="tel:6049807013" style={{color: '#6e0303', fontWeight: 'bold'}}>604-980-7013</a>.</p>
          </div>
          <div style={{display: 'flex', justifyContent: 'center'}}>
            <button 
              onClick={this.handleCloseStorageNotFoundDialog}
              style={{
                padding: '12px 30px',
                backgroundColor: '#c50000',
                color: '#fff',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    );
  }

  renderStorageConfirmDialog() {
    if (!this.state.storageConfirmDialogOpen) return null;
    
    const info = this.state.storageConfirmInfo || {};
    
    return (
      <div className="modal" style={{
        display: 'block',
        position: 'fixed',
        zIndex: 99999,
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        overflow: 'auto',
        backgroundColor: 'rgba(0,0,0,0.7)'
      }}>
        <div className="modal-content" style={{
          backgroundColor: '#fefefe',
          margin: '15% auto',
          padding: '30px',
          border: '1px solid #888',
          width: '80%',
          maxWidth: '500px',
          borderRadius: '10px'
        }}>
          <h3 style={{color: '#255706', marginBottom: '15px'}}>Stored Package Found</h3>
          <div style={{marginBottom: '20px', lineHeight: '1.8'}}>
            <p>
              You have a stored wheels/tires package with <strong>Sorat Wheels</strong> for this vehicle:{' '}
              <strong style={{color: '#c50000'}}>{info.vehicleName ? info.vehicleName : ''}</strong>
            </p>
            <p style={{marginTop: '10px', color: '#666'}}>
              Would you like to book using your stored package instead?
            </p>
          </div>
          <div style={{display: 'flex', gap: '10px', justifyContent: 'space-between'}}>
            <button
              onClick={this.handleStorageConfirmYes}
              style={{
                flex: 1,
                padding: '12px',
                backgroundColor: '#255706',
                color: '#fff',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              Yes, use my stored package
            </button>
            <button
              onClick={this.handleStorageConfirmNo}
              style={{
                flex: 1,
                padding: '12px',
                backgroundColor: '#c50000',
                color: '#fff',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              No, I will bring my own
            </button>
          </div>
        </div>
      </div>
    );
  }

  renderVehicleModal() {
    if (!this.state.vehicleModalOpen) return null;
    
    const isStorageMode = this.state.text === 'My Wheels and/or Tires are stored with Sorat Wheels';
    
    return (
      <div className="modal" style={{
        display: 'block',
        position: 'fixed',
        zIndex: 99999,
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        overflow: 'auto',
        backgroundColor: 'rgba(0,0,0,0.7)'
      }}>
        <div className="modal-content" style={{
          backgroundColor: '#fefefe',
          margin: '10% auto',
          padding: '30px',
          border: '1px solid #888',
          width: '90%',
          maxWidth: '600px',
          borderRadius: '10px'
        }}>
          <h3 style={{color: '#c50000', marginBottom: '20px', fontWeight: 'bold'}}>Select Your Vehicle</h3>
          <div style={{ marginBottom: '20px' }}>
            {this.state.customerVehicles.map((vehicleObj, index) => {
              const hasStorage = isStorageMode ? vehicleObj.hasStorage : true;
              return (
                <button
                  key={index}
                  type="button"
                  onClick={() => hasStorage && this.handleVehicleSelection(vehicleObj)}
                  disabled={!hasStorage}
                  style={{
                    width: '100%',
                    padding: '15px',
                    marginBottom: '10px',
                    backgroundColor: hasStorage ? '#c50000' : '#777',
                    color: '#fff',
                    border: '1px solid #666',
                    borderRadius: '5px',
                    cursor: hasStorage ? 'pointer' : 'not-allowed',
                    fontSize: '16px',
                    transition: 'all 0.3s',
                    opacity: hasStorage ? 1 : 0.5
                  }}
                  onMouseOver={(e) => { if (hasStorage) e.target.style.backgroundColor = '#8f0000'; }}
                  onMouseOut={(e) => { if (hasStorage) e.target.style.backgroundColor = '#c50000'; }}
                >
                  {vehicleObj.vehicle}
                </button>
              );
            })}
            {isStorageMode ? (
              <div style={{
                width: '100%',
                padding: '15px',
                marginTop: '10px',
                backgroundColor: '#f5f5f5',
                color: '#530909',
                border: '1px solid #ccc',
                borderRadius: '5px',
                fontSize: '15px',
                textAlign: 'center',
                fontWeight: 'bold'
              }}>
                If your vehicle is not listed above, please contact us (<a href="tel:6049807013" style={{ color: '#530909', textDecoration: 'underline' }}>604-980-7013</a>).
              </div>
            ) : (
              <button
                type="button"
                onClick={this.handleNewVehicleClick}
                style={{
                  width: '100%',
                  padding: '15px',
                  marginTop: '10px',
                  backgroundColor: '#c50000',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  fontWeight: 'bold'
                }}
              >
                + Add Different Vehicle
                <div style={{
                  fontSize: '11px',
                  fontWeight: 'normal',
                  marginTop: '0px',
                  fontStyle: 'italic',
                  opacity: '0.9'
                }}>
                  Click here if your vehicle is not listed above
                </div>
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }

  render() {
    // Show storage not found dialog on top of everything
    if (this.state.storageNotFoundDialogOpen) {
      return (
        <div>
          {this.renderStorageNotFoundDialog()}
        </div>
      );
    }

    // Show storage confirm dialog on top of everything
    if (this.state.storageConfirmDialogOpen) {
      return (
        <div>
          {this.renderStorageConfirmDialog()}
        </div>
      );
    }

    // Show duplicate dialog on top of everything
    if (this.state.duplicateDialogOpen) {
      return (
        <div>
          {this.renderDuplicateDialog()}
        </div>
      );
    }

    // Show vehicle selection modal
    if (this.state.vehicleModalOpen) {
      return (
        <div>
          {this.renderVehicleModal()}
        </div>
      );
    }
    
    if (this.state.loading) {
      return (
        <div>
          {navigator.userAgent.toLowerCase().indexOf('chrome') > -1 || navigator.userAgent.toLowerCase().indexOf('firefox') > -1 ?
            <img src={'https://www.soratwheels.ca/media/loading/loading.svg'}/> :
            <img src={'https://www.soratwheels.ca/media/loading/loading.gif'}/>}
        </div>
      );
    } 
    
    else if (this.state.StoreMyself) {
      window.localStorage.setItem("storage", "I have my Wheels/Tires and will bring with me to the appointment");
      return (

       <div style={{ height: 'auto', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          <br/>
          
          <div className="content-divLength" style={{minHeight: '550px', paddingTop: '2px !important'}}>
           <div id="sizesContainer_WheelsVehicle" className="size-selectingStaggeredOrNot custom_container">

             <h2 className="content-titleFont">I HAVE MY WHEELS / TIRES</h2>
             <div className='button-container' style={{
               display: 'flex',
               justifyContent: 'center',
               paddingTop: 5,
               paddingBottom: '15px',
               width: '100%'
             }}>

                <button className="size-selectingStaggeredOrNotBtn" onClick={() => {
                  this.setState({
                    StoreMyself: false,
                    text: 'My package is a pre mounted Wheel and Tire Package to simply be bolted on',
                    bookSorat: true,
                    loading: true
                  }, this.fetchBookingSettings);
                }}>
                  My package is a pre mounted Wheel and Tire Package to simply be bolted on
                </button>

                <button className="size-selectingStaggeredOrNotBtn" onClick={() => {
                  this.setState({
                    StoreMyself: false,
                    text: 'I have Loose tires that need to be mounted & balanced',
                    bookSorat: true,
                    loading: true
                  }, this.fetchBookingSettings);
                }}>
                  I have Loose tires that need to be mounted & balanced
                </button>
             </div>
           </div>
         </div>      
     </div>
      );

    } else if ( this.state.bookSorat && !this.state.selectedDate) {
      const todayRaw = this.state.serverDateString || this.getVancouverTodayRaw();
      const [todayYear, todayMonthNum, todayDayNum] = todayRaw.split('-').map(Number);
      const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      const todayFormatted = `${weekdays[new Date(Date.UTC(todayYear, todayMonthNum - 1, todayDayNum)).getUTCDay()]}, ${months[todayMonthNum - 1]} ${todayDayNum}, ${todayYear}`;
      
      const futureDates = this.getDatesFromToday(this.state.offsetDays, 12);
      const rows = [];
      for (let i = 0; i < futureDates.length; i += 4) {
        rows.push(futureDates.slice(i, i + 4));
      }

      return (
        <div style={{ height: 'auto', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
         <div className="content-divLength" style={{minHeight: '550px', paddingTop: '2px !important'}}>
          <div id="sizesContainer_WheelsVehicle" className="size-selectingStaggeredOrNot custom_container calendercss" style={{padding: '20px 10px 20px 10px'}}>
          <h2 className="calendertitle">Online Booking System</h2>
          <h4 className="calendertitle">Today: {todayFormatted}</h4>

  {rows.map((row, rowIndex) => (
    <div key={rowIndex} style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px', justifyContent: 'center' }}>
      {row.map(date => {
      
      const isSunday = date.isSunday;
      const isBlockedHoliday = this.state.blockedDates.includes(date.raw);
      const isFullyBookedDate = this.state.fullyBookedDates.includes(date.raw);
      const isSaturday = date.weekday === 'Saturday' && this.state.text === 'I have Loose tires that need to be mounted & balanced';
      const bookedTimesForDay = this.state.bookedTimes[date.raw] || [];

      // Dynamic time slots based on slotDuration
      let availableTimes = [];
      const startHour = (date.weekday === 'Saturday') ? 10 : 9;
      const endHour = (date.weekday === 'Saturday') ? 14 : 16;
      const slotDuration = this.state.slotDuration || 60; // 60 if not set

      for (let hour = startHour; hour <= endHour; hour++) {
        if (slotDuration === 30) {
          const formattedHour = hour.toString().padStart(2, '0');
          availableTimes.push(`${formattedHour}:00`);
          availableTimes.push(`${formattedHour}:30`);
        } else {
          const formattedHour = hour.toString().padStart(2, '0');
          availableTimes.push(`${formattedHour}:00`);
        }
      }

      // (Optional) Remove wrong :30 if exceeds working time
      if (slotDuration === 30 && !availableTimes.includes(`${endHour}:30`)) {
        availableTimes = availableTimes.filter(time => !time.endsWith(":30"));
      }

      const allowDoubleBooking = this.state.text === "My Wheels and/or Tires are stored with Sorat Wheels";

        const bookingCounts = {};
        bookedTimesForDay.forEach(time => {
          bookingCounts[time] = (bookingCounts[time] || 0) + 1;
        });
        
        const isFullyBooked = availableTimes.every(time => {
          const count = bookingCounts[time] || 0;
          return count >= this.getMaxBookingsForSlot(time);
        });

      // Final disable      isSaturday
      const isDisabled = isSunday || isBlockedHoliday || isFullyBookedDate || isFullyBooked;

      return (
        <button
          className="vehicleSelection-contentTires__btnlist"
          key={date.raw}
          onClick={() => !isDisabled && this.handleDateClick(date.raw, date.year, date.dayMonth, date.weekday)}
          style={{
            margin: '5px',
            padding: '8px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            boxShadow: 'inset 3px 3px 6px 1px #770404',
            height: 'auto',
            cursor: isDisabled ? 'not-allowed' : 'pointer',
            opacity: isDisabled ? 0.5 : 1
          }}
          disabled={isDisabled}
          title={
            isSunday ? 'Closed on Sunday'
            : (isFullyBookedDate || isFullyBooked) ? 'Fully booked for this day'
            : ''
          }
        >
                <span style={{backgroundColor: '#2d2b2b', width: 'inherit'}}>{date.weekday}</span>
                <span style={{textShadow: '1px -1px 2px black'}}>{date.dayMonth}</span>
                <span>{date.year}</span>
              </button>
            );
          })}
        </div>
      ))}
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                <button onClick={this.handlePrev} style={{ padding: '10px 20px', backgroundColor: '#444', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', width: '20%' }}>Prev</button>
                <button onClick={this.handleNext} style={{ padding: '10px 20px', backgroundColor: '#444', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', width: '20%' }}>Next</button>
              </div>

        </div>
             </div> 
                 </div>
      );

    } else if (this.state.selectedDate && !this.state.selectedTime) {
      return (
        <div style={{ height: 'auto', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
         <div className="content-divLength" style={{minHeight: '550px', paddingTop: '2px !important'}}>
          <div id="sizesContainer_WheelsVehicle" className="size-selectingStaggeredOrNot custom_container" style={{padding: '20px 10px 20px 10px'}}>
          
            <h4 style={{color: 'white', marginBottom: '15px'}}> Your Date: <strong style={{backgroundColor: '#c50000', padding: '10px'}}>{this.state.selectedDay}, {this.state.selectedMonth}, {this.state.selectedYear}</strong></h4>
            <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
              {this.renderTimeSlots()}
            </div>
            <button onClick={this.handleBack} style={{ padding: '20px 20px', backgroundColor: '#00000042', color: '#e9b1b1', border: 'none', textDecoration: 'underline', cursor: 'pointer' }}>
                  Back to Select Date
            </button>
        </div>
      </div>
    </div>
      );
    } else if (this.state.selectedTime && this.state.selectedDate && !this.state.booksubmited) {
      return (
        <div style={{ height: 'auto', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
         <div className="content-divLength" style={{minHeight: '550px', paddingTop: '2px !important'}}>
           <div id="sizesContainer_WheelsVehicle" className="size-selectingStaggeredOrNot custom_container" style={{padding: '20px 10px 20px 10px'}}>
              <h4 style={{color: 'white', marginBottom: '15px'}}> Your Date: <strong style={{backgroundColor: '#c50000', padding: '10px'}}>{this.state.selectedDay}, {this.state.selectedMonth}, {this.state.selectedYear}</strong></h4>
              <h4 style={{color: 'white', marginBottom: '15px'}}> Time: <strong style={{backgroundColor: '#c50000', padding: '10px'}}>{this.state.selectedTime}</strong></h4>
              {this.renderForm()}
           </div>
        </div>
      </div>
      );
    } else if (this.state.booksubmited && this.state.selectedTime && this.state.selectedDate && this.state.reservationCode) {

      return (
        <div style={{ height: 'auto', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}> 
         <div className="content-divLength" style={{minHeight: '550px', paddingTop: '2px !important'}}>
          <div id="sizesContainer_WheelsVehicle" className="size-selectingStaggeredOrNot custom_container" style={{padding: '20px 10px 20px 10px'}}>
        <h4 style={{ color: 'white', marginBottom: '15px' }}>Service Date: <strong style={{ backgroundColor: '#c50000', padding: '10px' }}>{this.state.selectedDay}, {this.state.selectedMonth}, {this.state.selectedYear}</strong></h4>
        <h4 style={{ color: 'white', marginBottom: '15px' }}>Service Time: <strong style={{ backgroundColor: '#c50000', padding: '10px' }}>{this.state.selectedTime}</strong></h4>
        <h4 style={{ color: 'white', marginBottom: '15px' }}>Reservation Code: <strong style={{ backgroundColor: '#c50000', padding: '10px' }}>{this.state.reservationCode}</strong></h4>
        {this.shouldBlockForTreadDepth(this.state.selectedTreadDepth) && (
          <h4 style={{ color: 'white', marginBottom: '15px' }}>
            <strong style={{ backgroundColor: '#c50000', padding: '10px' }}>
              Note: Your tires need to be replaced ({this.state.selectedTreadDepth}). Please call us at <a href="tel:6049807013" style={{ color: '#fff', textDecoration: 'underline' }}>604-980-7013</a>.
            </strong>
          </h4>
        )}
        <h4 style={{ color: 'white', marginBottom: '15px' }}><strong style={{ backgroundColor: 'Black', padding: '10px' }}>Your booking is confirmed</strong></h4>
        </div>
       </div>
      </div>
      );
    }

    return (
         <div className="breadcrumbbar__categoriesContainer">
           {this.renderSeasonalCategoryPanels()}   
       </div>
    );
  }
}

export default SeosonalSwap;



// WEBPACK FOOTER //
// ./src/components/SeasonalSwap.js